import { render, staticRenderFns } from "./ItemInfo.vue?vue&type=template&id=5b4d8303&"
import script from "./ItemInfo.vue?vue&type=script&lang=js&"
export * from "./ItemInfo.vue?vue&type=script&lang=js&"
import style0 from "./ItemInfo.vue?vue&type=style&index=0&id=5b4d8303&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports